import React from 'react';
import { FormItem, Input } from 'formik-antd';
import { GenderSelect } from 'common/components/GenderSelect';
import { AppDatePicker } from 'common/components/AppDatePicker';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useFormikContext } from 'formik';
import { BusinessPartnerPatientFormModel } from 'models/patient';
import { PersonalDocumentTypeSelect } from 'common/components/PersonalDocumentTypeSelect';
import { TrimmedFormikInput } from 'common/components/TrimmedFormikInput';
import { SubpartnersRegisterSelect } from 'common/components/SubpartnersSelect';
import { Checkbox } from 'antd';

export const BusinessPartnerEditPatientFormItems = (initialValues: any) => {
  const { values, setFieldValue } = useFormikContext<
    BusinessPartnerPatientFormModel
  >();
  const intlMessage = useFormatMessage();

  return (
    <>
      <FormItem
        label={intlMessage({ id: 'person.firstName' })}
        name="firstName"
        required
      >
        <Input name="firstName" />
      </FormItem>
      <FormItem
        label={intlMessage({ id: 'person.lastName' })}
        name="lastName"
        required
      >
        <Input name="lastName" />
      </FormItem>

      <FormItem
        label={intlMessage({ id: 'person.idNumberDocumentType' })}
        name="idNumberDocumentType"
      >
        <PersonalDocumentTypeSelect
          name="idNumberDocumentType"
          defaultValue="NON_REQUIRED"
          placeholder={intlMessage({
            id: 'personalDocument.NonRequiredDocument',
          })}
        />
      </FormItem>

      <FormItem
        label={intlMessage({ id: 'person.idNumber' })}
        name="idNumber"
        required={values.idNumberDocumentType !== 'NON_REQUIRED'}
      >
        <TrimmedFormikInput
          name="idNumber"
          disabled={values.idNumberDocumentType === 'NON_REQUIRED'}
        />
      </FormItem>

      <FormItem
        label={intlMessage({ id: 'person.dateOfBirth' })}
        name="dateOfBirth"
        required
      >
        <AppDatePicker name="dateOfBirth" />
      </FormItem>

      <FormItem
        label={intlMessage({ id: 'person.gender' })}
        name="gender"
        required
      >
        <GenderSelect name="gender" />
      </FormItem>

      <FormItem label="Email" name="email">
        <Input name="email" />
      </FormItem>

      <FormItem
        name="phone"
        label={intlMessage({ id: 'person.phoneNumber' })}
        style={{ display: 'flex', flexDirection: 'row', width: '100%' }}
      >
        <FormItem
          name="phoneNumber"
          style={{ marginBottom: '0', display: 'flex', width: '100%' }}
        >
          <FormItem
            name="prefixCode"
            style={{ marginBottom: '0', width: 95, display: 'inline-block' }}
          >
            <Input name="prefixCode" style={{ width: 95 }} addonBefore="+" />
          </FormItem>
          <Input style={{ width: 244, marginLeft: 10 }} name="phoneNumber" />
        </FormItem>
      </FormItem>

      <FormItem label={intlMessage({ id: 'partner' })} name="partner">
        <SubpartnersRegisterSelect
          defaultValue={
            initialValues.initialValues.partnerDetails
              ? initialValues.initialValues.partnerDetails.name
              : ''
          }
          disabled
          name="partner-edit"
        />
      </FormItem>

      <FormItem
        name="generalSurveyRequired"
        style={{ marginLeft: '200px', width: '100%' }}
      >
        <Checkbox
          checked={values.generalSurveyRequired}
          onChange={(e) =>
            setFieldValue('generalSurveyRequired', e.target.checked)
          }
        />
        <span style={{ marginLeft: '7px' }}>General survey required</span>
      </FormItem>
    </>
  );
};
